<template>
  <SubTitle :TitleName="'更新履歴'" />
  <v-card class="mx-auto w-75 mb-10" max-width="1280" variant="Tonal">
    <v-list :items="items" item-props lines="three">
      <template v-slot:subtitle="{ subtitle }">
        <div v-html="subtitle" class="subtitle_text"></div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  import SubTitle from "./SubTitle.vue";

  export default {
    data: () => ({
      items: [
        {
          title: "2026/4/24",
          subtitle: `ゲームガイドを公開いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2026/4/22",
          subtitle: `実況ガイドライン、特典コードの使用方法、不具合報告フォーム、スクリーンショットを公開いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2026/4/3",
          subtitle: `店舗特典を公開いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2025/12/12",
          subtitle: `サイトを公開いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
      ],
    }),
    components: {
      SubTitle,
    },
  };
</script>

<style scoped>
  .subtitle_text {
    font-size: 1.2em;
    line-height: 2em;
  }
</style>
